import React from 'react';
import { connect } from 'react-redux';
import TicketType from './TicketType';
import { hideModal } from '../store/ui';

const TicketCategory = ({ name, types, quantity, area, isJunior, maxQuantity, selected, shouldShowCategoryMessage, showedMessages, isMix }) => {

  const getAreaName = (area, name, types) => {
    if (+area === 0) {
      return 'butacas.png';
    }
    var type = types[0];
    var code = type.type.toLowerCase();
    switch (true) {
      case code.indexOf('cojin') >= 0: {
        return 'cojines.png';
      }
      case code.indexOf('tumbona') >= 0: {
        return 'tumbona.jpeg';
      }
      case code.indexOf('puff') >= 0: {
        return 'puff-doble.png';
      }
      default:
        return null;
    }
  };

  const salaMixImages = {
    premium: "premium_v2.png",
    tradicional: "tradicional_v2.png"
  }
  
  return (
    <div className="tickets__category">
      {
        isJunior &&
        <div className="tickets__category-img">
          {getAreaName(area, name, types) && <img src={require(`../static/images/${getAreaName(area, name, types)}`)} alt={name} />}
        </div>
      }
      {
        isMix && salaMixImages[name.toLowerCase()] && (
          <div className="tickets__category-img">
            <img src={require(`../static/images/sala-mix/${salaMixImages[name.toLowerCase()]}`)} alt={name} />
          </div>
      )}
      <div className="tickets__category-type">
        <h4 className="title2 ticket-title2">
          {
            isJunior && name.indexOf('tradicional') < 0
              ? <span><img src={require('../static/images/icons/logo-salajr.png')} alt="JUNIOR" />{name.replace(/junior/i, '')}</span>
              : name
          }
        </h4>
        <ul className="nostyle ticket__list">
          { types.map(ticketType => {
            return <TicketType
              key={`${area}-${ticketType.description}-${ticketType.folio}`}
              id={`${area}-${ticketType.description}-${ticketType.folio}`}
              name={ticketType.description.toUpperCase()}
              price={ticketType.price}
              code={ticketType.code}
              area={area}
              next={quantity < maxQuantity && (selected[`${area}-${ticketType.description}-${ticketType.folio}`] || 0) < ticketType.max_quantity}
              prev={quantity > 0}
              maxQuantity={maxQuantity}
              color={ticketType.color}
              message={ticketType.message}
              folio={ticketType.folio}
              showedMessages={showedMessages}
              shouldShowCategoryMessage={shouldShowCategoryMessage}
              min_quantity={ticketType.min_quantity || 1}
            />
          })}
        </ul>
      </div>
    </div>
  );
};


const showedMessages = new Set()
const mapStateToProps = ({ tickets, ui }, ownProps) => {
  const { modal } = ui
  const codesByMessageType = {}
  ownProps.types.forEach(type => {
    const { message, code } = type
    if(message === '') return
    if(!codesByMessageType[message]) codesByMessageType[message] = []
    codesByMessageType[message].push(code)
  })

  const shouldShowCategoryMessage = Object.keys(codesByMessageType).length > 0
  if(modal !== null && modal.message) showedMessages.add(modal.message)
  if(modal === null && shouldShowCategoryMessage) {
    const selectedCodes = tickets.selectedTickets.map(ticket => ticket.ticket_type_code)
    showedMessages.forEach(message => {
      const codes = codesByMessageType[message]
      if(codes) {
        const showAgain = codes.filter(code => selectedCodes.includes(code)).length === 0
        if(showAgain) showedMessages.delete(message)
      }
    })
  }
  
  return {
    modal,
    shouldShowCategoryMessage,
    showedMessages
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideModal: () => dispatch(hideModal()),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketCategory);
